import React from 'react';
import { Grid } from '@material-ui/core';
import ChartGauge from './../../../../components/ChartGauge';

class Risk extends React.Component{

  constructor() {
    super();
  }

  render(){
    if(this.props.risks.length === 0){
      return null
    }else{
      let xsGrid = 12/this.props.risks.length;
      return (
        this.props.risks.map((item, index) =>
          <Grid className="grid-chart" key={index} item xs={xsGrid}>
            <ChartGauge key={index+xsGrid} title={item.title} risk={item.risk}/>
          </Grid>
        )
      );
    }
  }

}

export default Risk;
